import { getSubmittedPaymentsAmountMap } from 'modules/cart/utils';

import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  submitted: false,
  submitting: false,
  paymentError: false,
  paymentErrorMessage: null,
  overrideModalNeed: false,
  orderId: null,
  orderData: {},
  totalSpentAmount: 0,
  orderMetaData: {
    transactionNumber: null,
    orderNumber: null,
  },
  paymentsAuthData: [],
  giftCardsAuthData: [],
  submittedPaymentsAmountMap: [],
  submittedGiftCardAmountMap: [],
  failedPaymentsKeys: [],
  failedGiftCardNumbers: [],
};

/**
 * Get total amount of succeeded gift and credit cards payments
 * @returns {Number}
 */
const calculateSpentAmount = ({ cardResponses, giftCardResponses, selectedPayments, selectedGiftCards }) => {
  const { failedPaymentsKeyIdentifiers } = cardResponses;
  const { failedGiftCardNumbers } = giftCardResponses;

  const creditCardsSum = selectedPayments.reduce(
    (acc, { amount, keyIdentifier }) =>
      failedPaymentsKeyIdentifiers.includes(keyIdentifier) ? acc : Number(amount) + acc,
    0,
  );

  const giftCardsSum = selectedGiftCards.reduce(
    (acc, { selectedBalance, giftCardNumber }) =>
      failedGiftCardNumbers.includes(giftCardNumber) ? acc : Number(selectedBalance) + acc,
    0,
  );

  return creditCardsSum + giftCardsSum;
};

/**
 * Get mapping of succeeded gift cards numbers and spent amounts
 * @returns {Object} [{giftCardNumber: amount}]
 */
const getSubmittedGiftCardAmountMap = (selectedGiftCards, failedGiftCardNumbers) => {
  const result = {};

  selectedGiftCards.forEach(({ giftCardNumber, selectedBalance }) => {
    if (!failedGiftCardNumbers.includes(giftCardNumber)) {
      result[giftCardNumber] = selectedBalance;
    }
  });

  return result;
};

const checkout = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.CHECKOUT_SUBMIT_ORDER_SUBMITTING:
      return { ...state, paymentError: false, submitting: true };

    case actionTypes.CHECKOUT_CACHE_ORDER_DATA:
      return { ...state, orderData: payload };

    case actionTypes.CHECKOUT_SUBMIT_ORDER_ERROR:
      return { ...state, submitting: false };

    case actionTypes.CHECKOUT_PAYMENT_ERROR:
      // eslint-disable-next-line no-case-declarations
      const { failedPaymentsKeyIdentifiers, successfulResponses, errorMessage } = payload.cardResponses;
      // eslint-disable-next-line no-case-declarations
      const { failedGiftCardNumbers, successfulResponses: successfulGCResponses } = payload.giftCardResponses;

      return {
        ...state,
        failedGiftCardNumbers,
        failedPaymentsKeys: failedPaymentsKeyIdentifiers,
        paymentErrorMessage: errorMessage,
        paymentsAuthData: successfulResponses,
        giftCardsAuthData: successfulGCResponses,
        submittedGiftCardAmountMap: getSubmittedGiftCardAmountMap(payload.selectedGiftCards, failedGiftCardNumbers),
        submittedPaymentsAmountMap: getSubmittedPaymentsAmountMap(
          payload.selectedPayments,
          failedPaymentsKeyIdentifiers,
        ),
        totalSpentAmount: state.totalSpentAmount + calculateSpentAmount(payload),
        paymentError: true,
      };

    case actionTypes.CHECKOUT_PAYMENT_CARD_VALIDATION_ERROR:
      return {
        ...state,
        failedPaymentsKeys: [payload.validatedCardKey],
        paymentErrorMessage: payload.errorMessage,
      };

    case actionTypes.CHECKOUT_OVERRIDE_MODAL_NEED:
      return { ...state, submitting: false, overrideModalNeed: true };

    case actionTypes.CHECKOUT_RESET_OVERRIDE_MODAL_NEED:
      return { ...state, overrideModalNeed: false };

    case actionTypes.CHECKOUT_SET_ORDER_META_DATA:
      return { ...state, orderMetaData: payload };

    case actionTypes.CHECKOUT_SUBMIT_ORDER_SUCCESS:
      return { ...INITIAL_STATE, submitted: true, orderId: payload };

    case actionTypes.CHECKOUT_VOID_ORDER_SUBMITTING:
      return { ...state, submitting: true };

    case actionTypes.CHECKOUT_VOID_ORDER_COMPLETE:
      return {
        ...INITIAL_STATE,
        // we need to save orderMetaData for all checkout session till successful submit order
        orderMetaData: state.orderMetaData,
        submitting: false,
      };

    case actionTypes.CHECKOUT_RESET:
      return { ...INITIAL_STATE };

    default:
      return state;
  }
};

export default checkout;
